import queryString from 'qs';

export const getTalkingPointListRequest = (queryParams) => {
  const queries = { limit: 10, page: queryParams?.page };

  if (queryParams?.brand?.value) queries['brands.name'] = queryParams?.brand?.value;
  if (queryParams?.talkingPoint?.statusDraft?.label) queries['isPublished'] = queryParams?.talkingPoint?.statusDraft?.value;
  if (queryParams?.talkingPoint?.status?.value) queries['status'] = queryParams?.talkingPoint?.status?.value;
  if (queryParams?.sort) queries['sort'] = `${queryParams?.sort?.field}.${queryParams?.sort?.order}`;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getTalkingPointListRequest;
